export const COMPONENT_NAME = 'Explore Map';
export const EXPLORE_MAP_TEMPLATE_ID = '97d8c0b8-9fe3-498a-9aed-3485ab93c648';